const CDN_URL = process.env.REACT_APP_CDN_URL;

const about = {
  title: "Our Story",

  story1: `It all started with a simple question: "How do I get really large pictures on my wall?"  
  As a professional picture hanger, Nils kept hearing this over and over. We tried wallpaper and vinyl,  
  but they peeled, bubbled, or just didn’t look great. That’s when we discovered vertical wall printing—  
  a way to print directly onto walls.`,

  story2: `Excited by the possibilities, we bought our first vertical wall printer from Alibaba, thinking we had found  
  the perfect tool. But no matter how much we adjusted, it never performed the way we needed.  
  The prints weren’t crisp, the colors weren’t reliable, and it just wasn’t good enough.  
  Before giving up, we took a leap and invested in the German-engineered wallPen—and it changed everything.`,

  story3: `The wallPen’s precision and quality blew us away, and we knew we had something special.  
  We even launched a YouTube channel, "Will It Print?", to see just how far we could push the technology.  
  From surfboards to window blinds, if it could stand upright, we printed on it.  
  Now, we’re bringing this game-changing tech to businesses and creatives everywhere.`,

  videoUrl: "https://www.youtube.com/watch?v=jaxUEVq2NBY",

  aboutImage: `${CDN_URL}/about/DSC00252_Kopie.jpg`,

  team: [
    {
      name: "Doug Marriott",
      role: "Owner – Operations",
      image: `${CDN_URL}/about/Doug_Marriott_Owner.jpg`,
    },
    {
      name: "Dave Griffin",
      role: "Owner – Business Development",
      image: `${CDN_URL}/about/Dave_Griffin_Owner.jpg`,
    },
    {
      name: "Nils Rasmusson",
      role: "Owner – Marketing",
      image: `${CDN_URL}/about/Nils_Rassmusen_Owner.jpg`,
    },
    {
      name: "Domus Go",
      role: "Sales Partner",
      image: `${CDN_URL}/about/Domus_Go_Partner.jpg`,
    },
    {
      name: "Cliff Little",
      role: "Operations",
      image: `${CDN_URL}/about/Cliff_Little_Operations.jpg`,
    },
  ],
};

export default about;
